export default {
    title: "Zalecenia doradcy",
    noItems: "Brak zaleceń"
}